import {ChangeDetectorRef, Component, forwardRef, HostListener} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractCheckboxInput} from "../abstract-checkbox-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIEditCheckboxInputComponent),
            multi: true
        }
    ],
    selector: "fui-edit-checkbox-input",
    styleUrls: ["./edit-checkbox-input.component.scss"],
    templateUrl: "./edit-checkbox-input.component.html",
    standalone: false
})
export class FUIEditCheckboxInputComponent extends FUIAbstractCheckboxInput {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }
}
